import React from 'react';

import * as analytics from 'analytics/Analytics';
import {setWindowTitle} from 'BenchlingUtil';
import {EVENTS_ANALYTICS_ACTIONS} from 'constants/AnalyticsConstants';
import {Header1} from 'ui-library/Headers';

import EventSubscriptionsListing from './EventSubscriptionsListing';

export function trackDocumentationClick(documentationDescription: string): void {
  analytics.deprecatedTrackEvent(EVENTS_ANALYTICS_ACTIONS.OPENED_EVENTS_DOCUMENTATION, {
    documentation_type: documentationDescription,
  });
}

export default function EventSubscriptionsPage(): JSX.Element {
  setWindowTitle('Events');
  analytics.deprecatedTrackEvent(EVENTS_ANALYTICS_ACTIONS.OPENED_DEVELOPER_CONSOLE);
  return (
    <div className="settingsPage legacy-font-proxima-13">
      <div className="settingsPage-contentWrapper">
        <Header1>Events</Header1>
        <p id="__documentation-info">
          For information about how to configure and use events, read our{' '}
          <a
            id="__getting_started_link"
            target="_blank"
            rel="noopener noreferrer"
            href="https://docs.benchling.com/docs/events-getting-started"
            onClick={() => {
              trackDocumentationClick('getting-started');
            }}
          >
            Events Getting Started Guide
          </a>{' '}
          and our{' '}
          <a
            id="__developer_platform_overview_link"
            target="_blank"
            rel="noopener noreferrer"
            href="https://docs.benchling.com/docs/developer-platform-overview"
            onClick={() => {
              trackDocumentationClick('developer-platform-overview');
            }}
          >
            Developer Platform Overview
          </a>
          .
        </p>
        <div className="u-spacing-top">
          <EventSubscriptionsListing />
        </div>
      </div>
    </div>
  );
}
